import { useRef, useEffect } from "react";

type IsMountedData = {
  isMounted: boolean;
};
const useIsMounted = (): IsMountedData => {
  const isMounted = useRef(false);

  useEffect(() => {
    if (isMounted.current === false) {
      isMounted.current = true;
    }
  }, []);

  return { isMounted: isMounted.current };
};

export { useIsMounted };
